module.exports = __webpack_public_path__ + "img/Group 1031.454b2212.png";